<footer [class.home-page]="isHomePage">
  <div class="footer-top">
    <div class="footer-left">
      <div class="logo">
        <img src="assets/logos/cliente-a.png" alt="Logo del cliente" />
      </div>
      <div class="social-icons">
        <a href="https://www.facebook.com/ike.asistencia.mexico/?locale=es_LA" target="_blank"><img src="assets/social/face.png"/></a>
        <a href="https://www.instagram.com/ike.mexico/?hl=es" target="_blank"><img src="assets/social/insta.png"/></a>
        <a href="https://mx.linkedin.com/company/like-asistencia" target="_blank"><img src="assets/social/in.png"/></a>
        <a href="" target="_blank" hidden><img src="assets/social/spo.png"/></a>
      </div>
    </div>

    <div class="footer-right">
      <div class="links">
        <!-- <a href="/privacy">Aviso de privacidad</a> -->
        <!-- <a href="assets/docs/TYC.pdf">Términos y condiciones</a> -->
        <!-- <a href="https://sitio-pwa-asistencias.dev-pruebas.com/faqs" hidden>Preguntas frecuentes</a> -->
        <!-- <a href="/contact" hidden>Contacto</a> -->
        <a href="assets/docs/aviso-privacidad.pdf" target="_blank">Aviso de privacidad</a>
        <a href="assets/docs/TYC.pdf" target="_blank">Términos y condiciones</a>
        <!-- <a (click)="navigateToFaq()" style="cursor: pointer;">Ayuda</a> -->
        <!-- <a [href]="getContactUrl()">Contacto</a> -->
        <a *ngIf="showLogoutLink" (click)="logout()" style="cursor: pointer;">Cerrar sesión</a>
      </div>
    </div>
  </div>

  <div class="footer-bottom">
    <div class="copyright">
      &copy; Iké asistencia | {{ currentYear }} | v{{ appVersion }} | Todos los derechos reservados.
    </div>
  </div>
</footer>
